import { IColumnStuLvl } from 'Src/ng2/shared/models/list-models';

export interface IInternalView {
  label: string;
  state: string;
}

export const COLUMNS: IColumnStuLvl[] = [
  {
    columnName: 'FILE_NAME',
    columnDataType: 'string',
    columnOrder: 0,
    graphQlKey: 'FILE_NAME',
  },
  {
    columnName: 'CREATOR',
    columnDataType: 'string',
    columnOrder: 1,
    graphQlKey: 'CREATED_BY',
  },
  {
    columnName: 'CREATED ON',
    columnDataType: 'Date',
    columnOrder: 2,
    graphQlKey: 'CREATED_ON',
  },
  {
    columnName: '',
    columnDataType: 'string',
    columnOrder: 3,
    graphQlKey: 'TRASH',
  },
];

export const SHEET_COLUMNS: IColumnStuLvl[] = [
  {
    columnName: 'FILE_NAME',
    columnDataFormat: 'string',
    columnOrder: 0,
    graphQlKey: 'FILE_NAME',
  },
  {
    columnName: 'CREATED ON',
    columnDataFormat: 'Date',
    columnOrder: 1,
    graphQlKey: 'CREATED_ON',
  },
];

export const GOOGLE_SHEETS_OPTIONS: string[] = [
  'Attendance heat map',
  'Mock regents',
  'Regents outreach',
  'Regents results',
  'Regents appeals',
  'Marking period',
  'SPELL management',
  'Student sorter',
  'Remote learning',
];

export const SHEET_TYPE_HUMAN_MAP = {
  'Attendance heat map': 'ATTENDANCE',
  'Marking period': 'MARKING PERIOD',
  'Mock regents': 'MOCK REGENTS',
  'Regents outreach': 'REGENTS OUTREACH',
  'Regents results': 'REGENTS RESULTS',
  'Regents appeals': 'REGENTS APPEALS',
  'Student sorter': 'SORTER',
  'SPELL management': 'SPELL MANAGEMENT',
  'Synced sheets': 'SYNCED_LIST',
  'Remote learning': 'REMOTE LEARNING',
};

export const SHEET_TYPE_TO_ROUTE = {
  'Attendance heat map': 'attendance',
  'Marking period': 'marking-period',
  'Mock regents': 'mock-regents',
  'Regents outreach': 'regents-outreach',
  'Regents results': 'regents-results',
  'Regents appeals': 'regents-appeals',
  'Student sorter': 'sorter',
  'SPELL management': 'spell-management',
  'Synced sheets': 'synced-sheets',
  'Remote learning': 'remote-learning',
  'Next term planning': 'next-term-planning',
  'Program changes': 'program-changes-and-gap-plans',
  Resources: 'resources',
};

export const VIEWS_TO_STATES = {
  'Next term planning': 'main.school.other-tools.next-term-planning',
  'Program changes': 'main.school.other-tools.program-changes-and-gap-plans',
  Resources: 'main.school.other-tools.resources',
};

export const SHEET_TYPE_MAPPINGS = {
  Attendance: 'Attendance heat map',
  'Mock Regents': 'Mock regents',
  'Regents Outreach': 'Regents outreach',
  'Regents Results': 'Regents results',
  'Regents Appeals': 'Regents appeals',
  'Marking Period': 'Marking period',
  'Spell Management': 'SPELL management',
  Sorter: 'Student sorter',
  'Remote Learning': 'Remote learning',
  Sync: 'Synced sheets',
};

export const DASH_TO_HUMAN = {
  'synced-sheets': 'Synced sheets',
  attendance: 'Attendance heat map',
  'mock-regents': 'Mock regents',
  'regents-outreach': 'Regents outreach',
  'regents-results': 'Regents results',
  'regents-appeals': 'Regents appeals',
  'marking-period': 'Marking period',
  'spell-management': 'SPELL management',
  sorter: 'Student sorter',
  'remote-learning': 'Remote learning',
  resources: 'Resources',
};

export const HUMAN_TO_DASH = {
  'Synced sheets': 'synced-sheets',
  'Attendance heat map': 'attendance-heat-map',
  'Mock regents': 'mock-regents',
  'Regents outreach': 'regents-outreach',
  'Regents results': 'regents-results',
  'Regents appeals': 'regents-appeals',
  'Marking period': 'marking-period',
  'SPELL management': 'spell-management',
  'Student sorter': 'student-sorter',
  'Remote learning': 'remote-learning',
  Resources: 'resources',
};

export const hsViews: IInternalView[] = [
  {
    label: `Next term planning`,
    state: `main.school.other-tools.next-term-planning`,
  },
  {
    label: `Program changes`,
    state: `main.school.other-tools.program-changes-and-gap-plans`,
  },
  {
    label: `Resources`,
    state: `main.school.other-tools.resources`,
  },
  {
    label: `Synced sheets`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `Attendance heat map`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `Mock regents`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `Regents outreach`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `Regents results`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `Regents appeals`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `Marking period`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `SPELL management`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `Student sorter`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `Remote learning`,
    state: `main.school.other-tools.default`,
  },
];

export const emsViews: IInternalView[] = [
  {
    label: `Resources`,
    state: `main.school.other-tools.resources`,
  },
  {
    label: `Synced sheets`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `Attendance heat map`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `Marking period`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `SPELL management`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `Student sorter`,
    state: `main.school.other-tools.default`,
  },
  {
    label: `Remote learning`,
    state: `main.school.other-tools.default`,
  },
];
